var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/dashboard",
        pageTitle: "Studio Health",
        backLink: "/dashboard/reports",
        showFooter: _vm.editing,
      },
      on: {
        save: function ($event) {
          return _vm.$refs.table.save()
        },
        cancel: function ($event) {
          return _vm.$refs.table.cancel()
        },
      },
    },
    [
      _vm.chartData.length
        ? _c("StudioHealthChart", { attrs: { chartData: _vm.chartData } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    ref: "reportHeader",
                    attrs: {
                      allLocations: _vm.allLocations,
                      locationOptions: "",
                      selectedLocation: _vm.selectedLocation,
                      updated: _vm.meta.updated_at,
                      subtitle: "Monthly Studio KPIs, earnings, and expenses",
                      filter: "",
                      filterData: !!(_vm.compareMonth || _vm.compareYear),
                      hideSearch: "",
                      monthSelector: "",
                      dateRange: _vm.dateRange,
                      reportUrl: "/dashboard/reports/studio-health/",
                      dateOptions: "month, year, quarter",
                    },
                    on: {
                      reset: function ($event) {
                        _vm.editing = false
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              [
                                _c("CompareMonth", {
                                  attrs: {
                                    value: _vm.compareMonth,
                                    disabled:
                                      !!_vm.compareYear || _vm.allLocations,
                                    date: _vm.dateRange[0],
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.$refs.reportHeader.updateRange(
                                        {
                                          rangeStart: _vm.dateRange[0],
                                          rangeEnd: _vm.dateRange[1],
                                          ...$event,
                                        }
                                      )
                                    },
                                    clear: function ($event) {
                                      return _vm.$refs.reportHeader.updateRange(
                                        {
                                          rangeStart: _vm.dateRange[0],
                                          rangeEnd: _vm.dateRange[1],
                                          ...$event,
                                        }
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      href: `/exports/studio-health/${_vm.$page.props.selectedLocation.id}?rangeStart=${_vm.dateRange[0]}&rangeEnd=${_vm.dateRange[1]}`,
                                      text: "",
                                      outlined: "",
                                      rounded: "",
                                      block: "",
                                      color: "dark",
                                      disabled:
                                        !!_vm.compareMonth ||
                                        _vm.allLocations ||
                                        !_vm.meta?.id,
                                    },
                                  },
                                  [
                                    _vm._v("Download as CSV"),
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", right: "" } },
                                      [_vm._v("download")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("StudioHealthTable", {
                        key: _vm.meta.id,
                        ref: "table",
                        attrs: {
                          columnOrder: _vm.columnOrder,
                          categoryOrder: _vm.categoryOrder,
                          headers: _vm.headers,
                          items: _vm.studioHealth,
                          meta: _vm.meta,
                          userEntry: !!(
                            !_vm.allLocations &&
                            !_vm.compareMonth &&
                            !_vm.compareYear &&
                            _vm.meta?.date
                          ),
                        },
                        on: {
                          editing: function ($event) {
                            _vm.editing = $event
                          },
                          success: function ($event) {
                            _vm.$refs.layout.showMessage = true
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }